// extracted by css-extract-rspack-plugin
export default {"root":"qigy0","list":"ZH2Ng","tabLabel":"oabm_","tab":"U4uPU","tabSection":"ZSoxq","tabClose":"f8NRY"};